module.exports = __webpack_public_path__ + "static/img/animales_29.5618c215.jpeg";